import { SOPNote } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { PlusIcon } from '@heroicons/react/24/outline';
import WorkflowFormNotes from '../WorkflowFormNotes';
import AIOperatorLabels from '../ai-operator-labels/AIOperatorLabels';
import CameraLabels from '../camera-labels/CameraLabels';
import TimeRangeLabels from '../time-range-labels/TimeRangeLabels';
import SOPCard from './SOPCard';
import { renderEmptyState } from '../utils';

interface Props {
  notes: SOPNote[];
  onChange: (val: SOPNote[]) => void;
  isEditing: boolean;
  locationId?: string;
}

export function SOPNotesCard(props: Props) {
  const { notes, onChange, isEditing, locationId } = props;

  const handleAddNote = () => {
    const updatedNotes = [...notes];
    updatedNotes.push({
      text: '',
      isRelevantForAiOperator: true,
      cameras: [],
    });
    onChange(updatedNotes);
  };

  const headerAction = isEditing ? (
    <Button
      variant="primary"
      onClick={handleAddNote}
      className="flex items-center gap-2"
    >
      <PlusIcon className="h-4 w-4" />
      Add
    </Button>
  ) : null;

  return (
    <SOPCard title="Notes" headerAction={headerAction}>
      {isEditing ? (
        <div className="space-y-4">
          <WorkflowFormNotes
            notes={notes}
            onChange={onChange}
            locationId={locationId}
          />
        </div>
      ) : notes && notes.length > 0 ? (
        <ol className="list-inside list-decimal space-y-4">
          {notes.map((note, i) => (
            <li key={i} className="text-onlight-text-2 dark:text-ondark-text-2">
              <span className="break-words">{note.text}</span>
              {(note.timeRange ||
                note.isRelevantForAiOperator !== undefined) && (
                <div className="my-2 flex flex-wrap gap-2 pl-4">
                  <AIOperatorLabels
                    isRelevantForAiOperator={note.isRelevantForAiOperator}
                  />
                  {note.timeRange && (
                    <TimeRangeLabels timeRange={note.timeRange} />
                  )}
                </div>
              )}
              {note.cameras && note.cameras.length > 0 && (
                <div className="flex flex-wrap gap-2 pl-4">
                  {note.cameras.map((camera, cameraIndex) => (
                    <CameraLabels key={cameraIndex} cameras={[camera]} />
                  ))}
                </div>
              )}
            </li>
          ))}
        </ol>
      ) : (
        renderEmptyState()
      )}
    </SOPCard>
  );
}

export default SOPNotesCard;
